import { render } from "./Download.vue?vue&type=template&id=4f927cdb&scoped=true"
const script = {}

import "./Download.vue?vue&type=style&index=0&id=4f927cdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f927cdb"]])

export default __exports__